import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { invalidateMeetingTypesQueries } from './useMeetingTypesQuery';

const BASE_API_KEY = 'scheduler/config';

export function useSchedulerConfigsQuery({
	userId,
	enabled = true,
	pageSize = 25,
	impersonationContext,
}: {
	userId?: string;
	enabled?: boolean;
	pageSize?: number;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IMeetingConfigResponse>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: {
						forUserId: userId,
						pageSize,
					},
					urlPath: 'scheduler/config',
				}),
				'GET'
			),
		queryKey: [BASE_API_KEY, impersonationContext, userId, pageSize],
		enabled,
	});
}

// Every meeting config change ends here, and a change can add, rename or remove a type in the merge-field picker.
export const invalidateSchedulerConfigsQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
	invalidateMeetingTypesQueries();
};
